import React from 'react';
import { LoadingSpinner } from '@cmp-src/loadings/LoadingSpinner';
import { Button } from '@cmp-src/buttons';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';

export const ReserveFormActions: React.FC = () => {
  const { isSubmitDisabled, isLoading } = useReserveForm();
  return (
    <Button
      type="submit"
      className="w-full"
      variant="primary"
      layout="rounded"
      font="boldPrimary"
      disabled={isSubmitDisabled}
    >
      {isLoading ? <LoadingSpinner color="text-white" /> : <span>Reserve</span>}
    </Button>
  );
};
